export default "__VITE_ASSET__qLvLaTYI__"